const copyUrl = () => {
  const copyBtnElement = document.querySelector(`.js-tool-copy`);

  if (copyBtnElement) {
    const urlElement = copyBtnElement.querySelector(`.js-copy-url`);
    const textElement = copyBtnElement.querySelector(`.js-copy-text`);

    function onCopyBtnElementClick() {
      getCopyContent();
    }

    function changeBtnText() {
      textElement.textContent = `Ссылка скопирована`;

      setTimeout(() => {
        textElement.textContent = `Скопировать ссылку`;
      }, 2000);
    }

    function getCopyContent() {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(urlElement.dataset.url)
          .then(() => {
            changeBtnText();
          })
          .catch((err) => {
            console.log("Something went wrong", err);
          });
      } else {
        // если API не доступно используем старый метод (deprecated)
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(urlElement);
        selection.removeAllRanges();
        selection.addRange(range);

        try {
          document.execCommand("copy");
          selection.removeAllRanges();

          changeBtnText();
        } catch (error) {
          console.log("Something went wrong", error);
        }
      }
    }

    copyBtnElement.addEventListener(`click`, onCopyBtnElementClick);
  }
};

export {copyUrl};
